import React from 'react';
import CreateImportForm from "v4/pages/admin/Import/components/ImportSteps/components/CreateImport/components/CreateImportForm/CreateImportForm";
import CreateImportInfo from "v4/pages/admin/Import/components/ImportSteps/components/CreateImport/components/CreateImportInfo/CreateImportInfo";
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function CreateImport() {
    const {t} = usePolTranslation();

    return (
        <div className="create-import">
            <AdminCard title={t('manage_import')}>
                <CreateImportForm/>
            </AdminCard>

            <AdminCard title={t('import_fields_available')}>
                <CreateImportInfo/>
            </AdminCard>
        </div>
    )
}
